import { ColumnDef } from "@tanstack/react-table";
import { formatMoney } from "@/core/utils/money";
import type { EnrichedIcmStatement } from "@/icm/types";

const StatementTotalPayoutCol: ColumnDef<EnrichedIcmStatement, unknown> = {
  id: "total_payout",
  accessorKey: "total_payout",
  header: "Total Pay",
  meta: { size: "120px" },
  cell: ({ getValue }) => formatMoney(getValue() as string),
};

export default StatementTotalPayoutCol;
